const routes = {
  home: { path: '/', title: 'Home' },
  analytics: { path: '/analytics', title: 'Analytics' },
  analyticsDetails: { path: '/:slug', title: 'Details' },
  about: { path: '/about', title: 'About us' },
  taxonomy: { path: '/taxonomy', title: 'Taxonomy' },
  submit: {
    path: '/submit',
    title: 'Submit your initiative',
  },
};

export default routes;

export const routesMenu = [
  routes.home,
  routes.taxonomy,
  routes.about,
  routes.submit,
];
